module.exports = __webpack_public_path__ + "img/3.0b87d109.png";